import { useContentfulLiveUpdates } from '@contentful/live-preview/react'
import resolveResponse from 'contentful-resolve-response'
import * as React from 'react'
import { useParams } from 'react-router-dom'

import { useContentAPI } from '../../../../Hooks/useAPI'
import PopUp from '../PopUp'

const MaterializedPopUp = () => {
  const params = useParams()
  const paths = Object.values(params).join('/')
  const isPreviewMode = paths.includes('preview/')

  const { data } = useContentAPI('contentType', 'popUpAlert', '', false)
  const previewData = useContentfulLiveUpdates(data)
  const resolver = {
    items: isPreviewMode ? previewData?.data?.items : data?.data?.items,
    includes: isPreviewMode ? previewData?.data?.includes : data?.data?.includes,
  }

  const contentData = data && data !== null ? resolveResponse(resolver)?.[0] : null
  if (!contentData) return <></>
  return (
    <>
      <PopUp
        title={contentData.fields.alertTitle}
        alertBody={contentData.fields.alertBody}
        expireDateTime={contentData.fields.alertEndDateTime}
        startingDateTime={contentData.fields.alertStartDateTime}
        version={contentData.sys.revision}
      />
    </>
  )
}

export default MaterializedPopUp
